import * as React from 'react'
import { SaveOutlined } from '@ant-design/icons'
import { Button, Form, Input, PageHeader } from 'antd'
import { RouteComponentProps, withRouter } from 'react-router'

import { IClienteService } from '../../services/ClienteService'
import { IClienteAdminService } from '../../services/ClienteAdminService'
import SERVICE_IDENTIFIER from '../../wires/Identifiers'
import container from '../../wires/Bootstrapper'

import { TTFormItem } from '../shared/TTFormItem'

import { ClienteModel } from '../../models/ClienteModels'
import { ClienteParams } from './ClienteParams'
import { withAITracking } from '@microsoft/applicationinsights-react-js'
import { ai } from '../../TelemetryService'
import {TTSelect} from "../shared/TTSelect";
import {renderSelectKeyValue} from "../shared/SelectOptionRenderUtils";

class ClienteEditState extends ClienteModel {
}

export class PageClienteEditComp extends React.Component<RouteComponentProps<ClienteParams>, ClienteEditState> {

    service: IClienteService
    adminService: IClienteAdminService

    constructor(props) {
        super(props)

        this.service = container.get(SERVICE_IDENTIFIER.CLIENTE_SERVICE)
        this.adminService = container.get(SERVICE_IDENTIFIER.CLIENTE_ADMIN_SERVICE)

        this.state = new ClienteEditState()
    }

    componentDidMount() {
        this.loadPage()
    }

    loadPage = async () => {
        let resp = await this.loadData()
        if (resp.IsValid == true)
            this.setState(resp)
    }

    loadData = async () => {
        let id = this.props.match.params.id
        if (id == null)
            return await this.service.Get()
        else
            return await this.adminService.GetById(id)
    }

    onSaveClick = async () => {
        let resp = await this.service.Save(this.state)
        if (resp.IsValid == true )
            this.props.history.push(`/Cliente/Scheda/${resp.Id}`)
    }

    render() {
        return (
            <PageHeader title="Cliente" onBack={() => this.props.history.goBack()} extra={[
                <Button type="primary" key="save" icon={<SaveOutlined />} onClick={() => this.onSaveClick()}>Salva</Button>
            ]}>
                <Form>
                    <TTFormItem label="Ragione sociale" required={true}>
                        <Input value={this.state.Descrizione} onChange={e => this.setState({ Descrizione: e.target.value })} />
                    </TTFormItem>
                    <TTFormItem label="Telefono" required={true}>
                        <Input value={this.state.Telefono} onChange={e => this.setState({ Telefono: e.target.value })} />
                    </TTFormItem>
                    <TTFormItem label="Email" required={true}>
                        <Input type="email" value={this.state.Email} onChange={e => this.setState({ Email: e.target.value })} />
                    </TTFormItem>
                    <TTFormItem label="Partita IVA" required={true}>
                        <Input type="email" value={this.state.PIva} onChange={e => this.setState({ PIva: e.target.value })} />
                    </TTFormItem>
                    <TTFormItem  label="Ufficio" rules={[{ required: true }]}>
                        <TTSelect value={this.state.UfficioId} onChange={e => this.setState({ UfficioId: e.toString() })} >
                            {renderSelectKeyValue(this.state.Uffici)}
                        </TTSelect>
                    </TTFormItem>
                </Form>
            </PageHeader>
        )
    }
}

export const PageClienteEdit = withRouter(withAITracking(ai.reactPlugin, PageClienteEditComp,"PageClienteEdit"))
